import { compose } from 'recompose';

import SubscriberCreate from './SubscriberCreate';

const enhance = compose();

export default enhance(SubscriberCreate);
